'use strict';

/**
 * Init Current location Logic
 */
class TWER_CURRENT_LOCATION {

  /**
   * Сonstructor
   *
   * @param props
   */
  constructor(props) {
    TWER.map.once('idle', () => {
      if(props.userGeolocation) {
        const is_chrome = /chrom(e|ium)/.test( navigator.userAgent.toLowerCase() );
        const is_ssl    = 'https:' == document.location.protocol;
        if( is_chrome && ! is_ssl ){
          return false;
        }

        navigator.geolocation.getCurrentPosition(( position ) => {
            TWER.map.flyTo({
              center: [
                position.coords.longitude,
                position.coords.latitude
              ],
              zoom: 15,
              essential: true,
            },{
              userLocation : [position.coords.longitude, position.coords.latitude]
            });
          }, () => {
            const lnglat = TWER.map.getCenter();
            TWER.map.flyTo({
              center: lnglat,
              essential: true,
            },{
              userLocation : lnglat
            });
          }
        );
      }
    });
  }
}

export default TWER_CURRENT_LOCATION;
